import { Component, Output, EventEmitter, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { DatePipe } from '@angular/common';

import { FormControl, Validators } from '@angular/forms';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';
import { MatOption } from '@angular/material';

import { GlobalsPaths } from '../../../app.config';
import { WeekPipe } from '../../../_services/weekPipe.service';
import { VehiclesGroupsService } from '../../../_services/vehicles-groups.service';
import { APIsettings } from '../../../app.config';
import { PaginationParams } from '../../../_models/generic';
import { IEventType } from '../../../_models/tracker';
import * as moment from 'moment';
import { timingSafeEqual } from 'crypto';
import { IMyDrpOptions, IMyDateRange } from 'mydaterangepicker';
import { Subscription } from 'rxjs';


@Component({
  moduleId: module.id,
  selector: 'events-sidebar',
  templateUrl: `./events-sidebar.html`
})



export class EventsSidebarComponent implements OnInit, OnDestroy {
  static LOCALSTORE_SELECTED_VEHICLE_NAME = 'selectedVehicle';
  static LOCALSTORE_SEARCH_FIELDS_NAME = 'searchFields';
  static LOCALSTORE_SEARCH_DATE_DAY = 'dateDay';


  img: string = this.globalsPaths.img;
  selectedVehicle: ISelectedVehile = { id: undefined, registration: undefined, type: undefined };
  isLoading: boolean = true;
  vehicleCtrl: FormControl;
  searchAutocomplete: string; // selcted vehicle value from vehicle serch box
  timeWeek: string;
  showPage: boolean = true;
  day: string;
  prefs: string;
  urlParams: Object;
  userPerm: any = JSON.parse(localStorage.getItem('userPerm')).perms;
  timesheetDetails: any; // stored in local storage
  startDateTime: Date;
  endDateTime: Date;
  private today = new Date();
  public myDateRangePickerOptions: IMyDrpOptions = {
    // other options...
    dateFormat: 'dd.mm.yyyy',
    firstDayOfWeek: 'mo',
    height: '44px',
    width: '220px',
    inline: false,
    alignSelectorRight: false,
    disableSince: { year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: (this.today.getDate() + 1) },
    editableDateRangeField: false,
    openSelectorOnInputClick: true
  };
  public dateRange: IMyDateRange;

  urlParaSub: any;
  hasTraceParamsInUrl: boolean = false;
  // List of vehicles to search
  vehicle: any = [];

  // List of vehicles groups -- may not be needed
  userVehicleGroupList: any = [];
  selectedVehicleId: number;
  urlPassedVehicleId: number;
  firstLoad: boolean = true;
  private vehicleList: any = [];

  localStoreSelectedVehicle: any = JSON.parse(localStorage.getItem(EventsSidebarComponent.LOCALSTORE_SELECTED_VEHICLE_NAME));
  localSearchField: any = JSON.parse(localStorage.getItem(EventsSidebarComponent.LOCALSTORE_SEARCH_FIELDS_NAME));
  localSearchDateDay: any = JSON.parse(localStorage.getItem(EventsSidebarComponent.LOCALSTORE_SEARCH_DATE_DAY));
  // Date buttons days
  dropdownTripsStopsSelect: string = 'today';
  dropdownTripsStops: any = [
    { value: 'today', viewValue: 'Today' },
    { value: 'yesterday', viewValue: 'Yesterday' },
    { value: 'custom', viewValue: 'Custom' }
  ];

  eventTypeList: Array<IEventType> = [
    { name: 'Ignition On', eventCode: 4 },
    { name: 'Ignition Off', eventCode: 5 },
    { name: 'Beacon Lights Active', eventCode: 52 },
    { name: 'Harsh Acceleration', eventCode: 40 },
    { name: 'Harsh Braking', eventCode: 41 },
    { name: 'Harsh Cornering', eventCode: 42 },
    { name: 'Panic Button', eventCode: 50 },
    { name: 'Run Lock Active', eventCode: 53 },
  ];
  eventTypeSelect = new FormControl(this.eventTypeList[1], [Validators.required]);
  selectAllValue: IEventType = {
    eventCode: -1,
    name: ''
  };
  @Output() outputShowPage: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() outputVehicleName: EventEmitter<string> = new EventEmitter<string>();
  @Output() outputVehicleType: EventEmitter<string> = new EventEmitter<string>();
  @Output() outputVehicleId: EventEmitter<number> = new EventEmitter<number>();
  @Output() outputStartDateTime: EventEmitter<Date> = new EventEmitter<Date>();
  @Output() outputEndDateTime: EventEmitter<Date> = new EventEmitter<Date>();
  @Output() outputTraceTitle: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() outputApiIsLoading: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() outputEventType: EventEmitter<IEventType> = new EventEmitter<IEventType>();
  @ViewChild('allSelected') private allSelected: MatOption;

  componentDestroyed$: Subject<boolean> = new Subject();

  constructor(private router: Router,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private vehiclesGroupsService: VehiclesGroupsService,
    private activatedRoute: ActivatedRoute,
    private globalsPaths: GlobalsPaths,
    private apiSettings: APIsettings) {


  }

  ngOnInit() {
    this.vehicleCtrl = new FormControl();
    this.outputApiIsLoading.emit(true);
    this.getUsersVehicleGroups();
    const _selectedArr = this.eventTypeList.filter(x => x.eventCode > 5);
    // _selectedArr.shift();
    console.log('Event type list: ', _selectedArr);
    // Set event type select item
    this.eventTypeSelect.setValue(_selectedArr);
    this.outputEventType.emit(this.eventTypeSelect.value);

    // // Set the date range picker
    this.myDateRangePickerOptions.dateFormat = JSON.parse(localStorage.getItem('currentUser')).user.prefs.date_format.toLowerCase();
    this.setDateRangePickerValues();
    // Check if Trace parameters have been passed into urls
    this.urlParaSub = this.route.queryParams.subscribe(params => {
      console.log('Trace URL Params: ', params);

      if (params['vehicleId'] && params['startDate']) {
        console.log('There are url parameters that can create a trace');
        const _vehicleId = params['vehicleId'];
        this.selectedVehicleId = parseInt(_vehicleId);
        this.urlPassedVehicleId = parseInt(_vehicleId);
        const _startDay = params['startDate'];
        this.day = this.datePipe.transform(_startDay, 'yyyy-MM-dd');

        this.hasTraceParamsInUrl = true;
      }
    });

    this.determineDistance();

    if (this.userPerm.is_limited_user === false) {
      this.searchInf();
    }

  }
  ngAfterViewInit() {
    // this.allSelected.select();
    // this.toggleAllSelection();

    // console.log('this.allSelected.select(); ', this.allSelected.viewValue);
  }

  ngOnDestroy() {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }

  onDateRangeChanged(event) {
    this.setDateRangePickerValues(event);
  }

  public getUsersVehicleGroups() {
    const _paramsVG: PaginationParams = {
      pageSize: 400,
      page: 1,
      orderingDirection: '',
      ordering: 'name',
      search: ''
    };

    // Gets the vehicle groups and vehilces for the vehicle list o-content__sidebar
    this.vehiclesGroupsService.getVehiclesGroupsOnlyTrackers(_paramsVG)
      .takeUntil(this.componentDestroyed$)
      .subscribe(data => {
        const _data = data['vehicle_groups'];
        console.log('Subscribed #1 - to getVehicleGroups GET');
        for (const i in _data) {
          if (_data[i].vehicles.length > 0) {
            this.userVehicleGroupList.push(_data[i]);
            // Create a list of vehicles
            for (const j in _data[i].vehicles) {
              this.vehicleList.push(_data[i].vehicles[j]);
            }
          }
        }
        console.log('userVehicleGroupList', this.userVehicleGroupList);
        // Selected vehicle
        this.selectVehicle();

        this.isLoading = false;

        // TODO - move this and have it check if the localstoarage is set and not waiting for this subscription to complete
        this.searchOnDay();
      });
  }

  private getSelectedVehicleById(vehicleId: number) {
    const _selectedVehicle = this.vehicleList.find(function (obj) { return obj.id === vehicleId; });
    return _selectedVehicle;
  }

  public determineDistance() {
    const userPerm = JSON.parse(localStorage.getItem('userPerm'));
    if (userPerm && userPerm.prefs != null) {
      this.prefs = userPerm.prefs;
    } else {
      this.prefs = 'MLS';
    }
  }

  // Initialises the initial values for the search side bar.
  // Pulls previous stored params from local storage and sets the date picker
  public searchInf() {

    // Dont update the day date if it's been set by URL params
    if (!this.hasTraceParamsInUrl) {
      if (this.localSearchDateDay) {
        this.day = this.localSearchDateDay;
      } else {
        // Set dates for search
        const today = new Date();
        // Set to current todays date
        const dayFormated = this.datePipe.transform(today, 'yyyy-MM-dd');
        this.day = dayFormated;
      }
      this.setDateRangePickerValues();
    }

    // Can't output this until vehicle groups loaded?
    this.outputTraceTitle.emit(true);
    this.outputVehicleName.emit(this.searchAutocomplete);
    this.outputApiIsLoading.emit(true);
    this.isLoading = true;
    this.todayYesterday(this.day);
  };

  private setDateRangePickerValues(event?) {
    let _startDate;
    let _endDate;
    let _rangeStartDate: { year: number; month: number; day: number; };
    let _rangeEndDate: { year: number; month: number; day: number; };

    // If coming from a datepicker change interaction
    if (event) {
      // _startDate = new Date(event.beginJsDate);
      // _endDate = new Date(event.endJsDate);
      if (event.formatted.length > 0 || event.endEpoc > 0) {
        // const startDate = `${event.beginDate.day}-${event.beginDate.month}-${event.beginDate.year}`;
        // const endDate = `${event.endDate.day}-${event.endDate.month}-${event.endDate.year}`;
        _startDate = new Date(event.beginJsDate);
        _endDate = new Date(event.endJsDate);

        // this.madeInDatesText = `dates from ${startDate} to ${endDate}`;
      }
    } else {
      // Initialise the date range picker - initialise to todays date
      // _startDate = this.day != null ? new Date(this.day) : new Date();
      _startDate = new Date();
      _startDate.setHours(0, 0, 0, 0); // Set time to 00:00
      _rangeEndDate = {
        year: _startDate.getFullYear(), month: _startDate.getMonth() + 1, day: _startDate.getDate()
      };
      // _startDate.setDate(_startDate.getDate() - 1);
      _rangeStartDate = {
        year: _startDate.getFullYear(), month: _startDate.getMonth() + 1, day: _startDate.getDate()
      };
      this.dateRange = {
        beginDate: _rangeStartDate,
        endDate: _rangeEndDate
      };

    }

    // Set start and end date Outputs and store in localstorage
    localStorage.setItem(EventsSidebarComponent.LOCALSTORE_SEARCH_DATE_DAY, JSON.stringify(moment(_startDate).format('YYYY-MM-DD')));
    this.startDateTime = _startDate;
    this.endDateTime = _endDate;

    // Move the end date time to midnight the next day
    // this.endDateTime.setHours(this.endDateTime.getHours() + 24);
  }

  public customFunctionality(option) {
    if (option === 'day' && this.dropdownTripsStopsSelect === 'custom') {
      return false;
    }
    return true;
  }

  public changeDateDayOption(event) {
    const today = moment(new Date()).format('YYYY-MM-DD');
    if (event === 'today') {
      this.day = today;
    } else if (event === 'yesterday') {
      this.day = moment(this.timeWeek).add(-1, 'days').format('YYYY-MM-DD');
    }
  }

  public addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  public toggleDay(option) {
    if (this.router.url !== '/timesheet') {
      const resultAddDay = this.addDays(this.day, option);
      const resultDate = moment(resultAddDay).format('YYYY-MM-DD');
      this.day = resultDate.toString();
    }
  }

  public todayYesterday(day) {
    const today = moment().format('YYYY-MM-DD');
    if (day === today) {
      this.dropdownTripsStopsSelect = 'today';
    } else {
      this.dropdownTripsStopsSelect = 'custom';
    }
  }

  public selectVehicle(vehicle?: any) {
    // // If the vehicle id is passed in as a parameter
    if (this.urlPassedVehicleId && this.firstLoad === true) {
      this.selectedVehicleId = this.urlPassedVehicleId;
      const _selectVehicle = this.getSelectedVehicleById(this.urlPassedVehicleId);
      this.selectedVehicle = { id: _selectVehicle.id, registration: _selectVehicle.registration, type: _selectVehicle.vehicle_type };
      this.firstLoad = false;
      return;
    }
    else if (vehicle) {
      this.selectedVehicle = { id: vehicle.id, registration: vehicle.registration, type: vehicle.type };
      this.selectedVehicleId = vehicle.id;
      return;
    }
    // get the vehicle id from local storage
    else if (this.localStoreSelectedVehicle != null && this.localStoreSelectedVehicle.id !== undefined) {
      const vehicle = this.localStoreSelectedVehicle;
      this.selectedVehicle = { id: vehicle.id, registration: vehicle.registration, type: vehicle.type };
      this.selectedVehicleId = vehicle.id;
      return;
    }
    // get the first vehilce in the first group
    else {
      const groupList = this.userVehicleGroupList;
      const firstVehicle = groupList[0].vehicles[0];
      this.selectedVehicle = { id: firstVehicle.id, registration: firstVehicle.registration, type: firstVehicle.type };
      this.selectedVehicleId = firstVehicle.id;
    }

  };

  public validSearch(validWeek, validVehicle) {
    if (validWeek === false && validVehicle === false) {
      return false;
    } else {
      return true;
    }
  };

  // Called when 'Search' button clicked
  public searchOnDay() {
    localStorage.setItem(EventsSidebarComponent.LOCALSTORE_SELECTED_VEHICLE_NAME, JSON.stringify(this.selectedVehicle));


    this.outputVehicleName.emit(this.selectedVehicle.registration);
    this.outputVehicleId.emit(this.selectedVehicle.id);
    this.outputVehicleType.emit(this.selectedVehicle.type);
    this.outputStartDateTime.emit(this.startDateTime);
    this.outputEndDateTime.emit(this.endDateTime);
    this.showPage = true;
    this.outputEventType.emit(this.eventTypeSelect.value);
    this.outputApiIsLoading.emit(false);
    this.isLoading = false;
    this.outputShowPage.emit(this.showPage); // force re-load of trace data

    return;

  };



  toggleOne(all, event) {
    if (this.allSelected.selected) {
      this.allSelected.deselect();
      return false;
    }
    if (this.eventTypeSelect.value.length === this.eventTypeList.length) {
      this.allSelected.select();
    }

    // if (this.eventTypeSelect.value.length > 0) { this.searchOnDay(); }
    this.searchOnDay();
  }

  toggleAllSelection() {
    if (this.allSelected.selected) {
      this.eventTypeSelect
        .patchValue([...this.eventTypeList.map(item => item), this.selectAllValue]);

      this.searchOnDay();
    } else {
      this.eventTypeSelect.patchValue([]);
      this.searchOnDay();
    }
  }

}

export interface ISelectedVehile {
  id: number;
  registration: string;
  type: string;
}






// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/Events/components/events-sidebar/events-sidebar.component.ts